import validator from 'validator';
import moment from 'moment';

export const required = (value, msg) => {
  if (!value.toString().trim().length) {
    return msg || 'this field should not be empty.';
  }
};

export const email = (value, msg) => {
  if (!validator.isEmail(value)) {
    return msg || `${value} is not a valid email.`;
  }
};

export const strLessThan = (count) => (value, msg) => {
  if (typeof value !== 'string' || value.length >= count) {
    return msg || `should be less than ${count}`;
  }
};

export const validatePeriod = (start_at, end_at, msg) => {
  if (moment(start_at).isSameOrAfter(moment(end_at))) {
    return msg || 'invalid period';
  }
};

// カタカナ + 長音符 + 中黒 + 全角/半角スペース + 半角/全角数字 + 半角/全角括弧 + ハイフンを許容
// (空文字は valid とみなす。空チェックは required で別途)
// 「2号店」「(本店)」のようなフリガナ表記に対応
const FURIGANA_PATTERN = /^[ァ-ヶー・\s 　0-9０-９()（）\-]+$/;
export const validateFurigana = (value) => {
  if (!value) return undefined;
  if (!FURIGANA_PATTERN.test(value)) {
    return 'カタカナ・数字・括弧で入力してください';
  }
  return undefined;
};

// 半角数字 + ハイフン許容
const TEL_PATTERN = /^[0-9-]+$/;
export const validateTel = (value) => {
  if (!value) return undefined;
  if (!TEL_PATTERN.test(value)) {
    return '電話番号は半角数字とハイフンで入力してください';
  }
  return undefined;
};

// 郵便番号: 7 桁数字 (ハイフン許容)
const POSTAL_CODE_PATTERN = /^\d{3}-?\d{4}$/;
export const validatePostalCode = (value) => {
  if (!value) return undefined;
  if (!POSTAL_CODE_PATTERN.test(value)) {
    return '郵便番号は 7 桁の半角数字で入力してください';
  }
  return undefined;
};
